// src/models/bancoModel.js

import pb from '../lib/pocketbase';

export async function getBancos(page, perPage) {
  return await pb.collection('banco').getList(page, perPage, {
    sort: '-created',
    $autoCancel: false // Desactiva la auto-cancelación
  });
}

export async function createBanco(banco) {
  return await pb.collection('banco').create(banco);
}

export async function updateBanco(id, banco) {
  return await pb.collection('banco').update(id, banco);
}

export async function deleteBanco(id) {
  return await pb.collection('banco').delete(id);
}
